"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _server = require("react-dom/server");
var _Google = _interopRequireDefault(require("./assets/Google.svg"));
var _Apple = _interopRequireDefault(require("./assets/Apple.svg"));
var _excluded = ["children", "dataTestId", "href", "alt", "variant"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var propTypes = {
  children: _propTypes["default"].node,
  dataTestId: _propTypes["default"].string,
  href: _propTypes["default"].string.isRequired,
  alt: _propTypes["default"].string.isRequired,
  size: _propTypes["default"].oneOf(['large', 'medium', 'small']),
  variant: _propTypes["default"].oneOf(['google', 'apple'])
};
var defaultProps = {
  children: null,
  dataTestId: null,
  size: 'large',
  variant: 'google'
};
var sizeConfig = {
  medium: '40px',
  small: '32px'
};
var StyledButtonDownload = _styledComponents["default"].a.withConfig({
  displayName: "download-button__StyledButtonDownload",
  componentId: "sc-tzfzjx-0"
})(["display:inline-flex;position:relative;& img{display:flex;height:", ";}&:focus,&:active{border-radius:5px;outline:var(--spacing-global-space1) solid var(--color-functional-focus);}&:after{content:'';display:block;min-height:44px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);min-width:44px;width:100%;}"], function (props) {
  return sizeConfig[props.size] ? sizeConfig[props.size] : "48px";
});
function ButtonDownload(_ref) {
  var children = _ref.children,
    dataTestId = _ref.dataTestId,
    href = _ref.href,
    alt = _ref.alt,
    variant = _ref.variant,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledButtonDownload, _extends({
    className: "fuse-download-button",
    "data-testid": dataTestId,
    href: href,
    "aria-label": "".concat(alt, " link")
  }, other), /*#__PURE__*/_react["default"].createElement("img", {
    className: "fuse-download-button__image",
    alt: alt,
    src: "data:image/svg+xml;utf8,".concat(encodeURIComponent((0, _server.renderToStaticMarkup)(variant === 'apple' ? /*#__PURE__*/_react["default"].createElement(_Apple["default"], null) : /*#__PURE__*/_react["default"].createElement(_Google["default"], null))))
  }));
}
ButtonDownload.propTypes = propTypes;
ButtonDownload.defaultProps = defaultProps;
var _default = exports["default"] = ButtonDownload;